import { getKeyByTitleOrLabel } from 'commons/utils/array'
import { dateSubtract, formatDate, getEndOfDay, getStartOfDay } from 'commons/utils/date'
import type { EdiRequest, EdiStatus, EdiStatusOption } from 'constants/enums'

export const getEdiReprocessCode = (item: EdiRequest) => item.id

export interface EdiFilterValues {
  cnpj: string
  customerOrder: string
  endDate: string
  legalName: string
  sapCode: string
  startDate: string
  status: EdiStatus[]
}

export const getDefaultEdiFilterFormValues = (statusOptions: EdiStatusOption[]) => {
  const today = formatDate(new Date(), 'YYYY-MM-DDTHH:mm:ss')
  const yesterday = formatDate(
    dateSubtract(today, 1, 'day', 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DDTHH:mm:ss'),
    'YYYY-MM-DDTHH:mm:ss',
    'YYYY-MM-DDTHH:mm:ss',
  )

  return {
    cnpj: '',
    customerOrder: '',
    endDate: getEndOfDay(today, 'YYYY-MM-DDTHH:mm:ss'),
    legalName: '',
    sapCode: '',
    startDate: getStartOfDay(yesterday, 'YYYY-MM-DDTHH:mm:ss'),
    status: statusOptions.map((item) => item.title),
  }
}

export const getDefaultEdiFilters = (statusOptions: EdiStatusOption[]): EdiFilterValues => {
  const defaultValues = getDefaultEdiFilterFormValues(statusOptions)

  return {
    ...defaultValues,
    status: getKeyByTitleOrLabel(defaultValues.status, statusOptions) as EdiStatus[],
  }
}
